import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { SkuEntityListSpecification } from './SkuEntityListSpecification';

export class ForcedToZeroEntityListSpecification extends SkuEntityListSpecification {
  constructor() {
    super(
      ProjectAdministrationSubpage.FORCEDTOZEROLISTS,
      'Forced To Zero list administration',
      'Forced To Zero list',
      'Forced To Zero lists',
      'FTZ',
      [],
    );
  }
}
